import { Box, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";
import { BannerPromoCode, UpgradeDialogSource } from "schemas/dashboard";

import { trackEvent } from "utils/tracking";

import BannerWrapper from "../BannerWrapper";
import { useCountDown } from "../useCountdown";

interface Props {
  promo: BannerPromoCode;
}

const SaleBanner = ({ promo }: Props) => {
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const { display, createTimer } = useCountDown();

  useEffect(() => {
    createTimer(promo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promo.couponName]);

  if (!display) return null;

  const message =
    promo.description?.trim() ||
    (promo.discountPercent != null
      ? `${promo.discountPercent}% off — ends ${promo.dateEnding}`
      : `Sale ends ${promo.dateEnding}`);

  const handleClick = () => {
    trackEvent("Sale Banner Clicked", {
      "Coupon Name": promo.couponName,
      "Discount Percent": promo.discountPercent,
    });
    setUpgradeDialogSource(UpgradeDialogSource.countdown_banner);
  };

  return (
    <BannerWrapper onClick={handleClick}>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{ py: 0.5 }}
      >
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          {message} — ends in <strong>{display}</strong>
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ color: "white", ml: 1 }}
          />
        </Typography>
      </Grid>
    </BannerWrapper>
  );
};

export default SaleBanner;
